/* eslint-disable parog-web/no-glint-expect-error-directive */
import Component from '@glimmer/component';
import type { EmberChangeset } from 'ember-changeset';
import type { Signature as ForcProviderSignature } from 'parog-web/components/forc/provider';
import Checkbox from 'ui-kit/components/checkbox';

interface Signature {
  Args: {
    TextArea?: unknown;
    form?: ForcProviderSignature['Blocks']['content'][0];
    labelName?: unknown;
    changeset: EmberChangeset;
    propertyName: string;
  };
}

export default class CheckboxWithConditionalComment extends Component<Signature> {
  get isChecked() {
    return this.args.changeset.get(this.args.propertyName) != null;
  }

  #lastCommentValue = '';

  onChangedValue = value => {
    // When unchecking, cache the previous comment value
    if (!value) {
      this.#lastCommentValue = this.args.changeset.get(this.args.propertyName);
    }

    this.args.changeset.set(
      this.args.propertyName,
      value ? this.#lastCommentValue : null
    );
  };

  <template>
    <div class='field'>
      <Checkbox
        {{! @glint-expect-error }}
        @labelName={{@labelName}}
        @onChange={{this.onChangedValue}}
        @checked={{this.isChecked}}
        @dataTestInput={{@propertyName}}
      />
    </div>

    {{#if this.isChecked}}
      {{! @glint-expect-error }}
      {{yield}}
      <div class='field'>
        <@form.TextArea
          @labelName='Précisions'
          @propertyName={{@propertyName}}
          @rows={{3}}
        />
      </div>
      <div class='ui divider hidden'></div>
    {{/if}}
  </template>
}
